<div class="otp-container">
    <input *ngFor="let control of otpForm.controls | keyvalue; let i = index" #otpInput [formControl]="control.value"
        type="text" class="otp-box" maxlength="1" [ngClass]="{'error': errorState}"  (input)="handleInput($event, i)" (keydown)="handleInput($event, i)" (paste)="handlePaste($event)" />
</div>